import React, { memo } from "react";
import { CssBaseline, ThemeProvider as MUIThemeProvider, StyledEngineProvider } from "@mui/material";
import { useCpTheme } from "./theme";
const ThemeProvider = ({ children, mode = "light", theme }) => {
    const cpTheme = useCpTheme({ mode, theme });
    return (React.createElement(StyledEngineProvider, { injectFirst: true },
        React.createElement(MUIThemeProvider, { theme: cpTheme },
            React.createElement(CssBaseline, null),
            children)));
};
export default memo(ThemeProvider);
//# sourceMappingURL=ThemeProvider.js.map